module.exports = __webpack_public_path__ + "img/timeNode.6b12a157.png";